import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import defaultShield from '@sorare/core/src/assets/club/shield_none.png';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { fantasy } from '@sorare/core/src/lib/glossary';
import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from '../types';
import { getActiveClubsRule_so5Rules } from './__generated__/getActiveClubsRule.graphql';

export const getActiveClubsRule = withFragments(
  (
    rules: getActiveClubsRule_so5Rules,
    error: string
  ): RuleHelperFnReturnType => {
    const rule = rules.activeClubs;
    if (!rule?.length) {
      return null;
    }

    return {
      id: 'activeClubs',
      label: <FormattedMessage {...fantasy.playersPermittedFrom} />,
      description: (
        <Vertical as="span" gap={0}>
          {rule.map(club => (
            <Horizontal key={club.slug} as="span">
              <img
                src={club.pictureUrl || defaultShield}
                alt=""
                width="16"
                height="16"
              />
              {club.name}
            </Horizontal>
          ))}
        </Vertical>
      ),
      icon: (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.6641 10.8906C9.78299 10.8113 9.89512 10.7244 10 10.6306C10.6313 10.066 11 9.25462 11 8.39445V5.46484L8 4V12L9.6641 10.8906Z"
            fill="var(--c-rivals-win)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 3L8 0L15 3V7.35742C15 10.2283 13.4617 12.879 10.9691 14.3034L8 16L5.03089 14.3034C2.53829 12.879 1 10.2283 1 7.35742V3ZM3 7.35742V4.31879L8 2.17594L13 4.31879V7.35742C13 9.51056 11.8463 11.4986 9.97683 12.5669L8 13.6965L6.02317 12.5669C4.15372 11.4986 3 9.51056 3 7.35742Z"
            fill="var(--c-rivals-win)"
          />
        </svg>
      ),
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getActiveClubsRule_so5Rules on So5Rules {
        id
        activeClubs {
          slug
          name
          pictureUrl
        }
      }
    ` as TypedDocumentNode<getActiveClubsRule_so5Rules>,
  }
);
